/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface BlogArticle
 */
export interface BlogArticle {
    /**
     * 
     * @type {number}
     * @memberof BlogArticle
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BlogArticle
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof BlogArticle
     */
    'hoverText': string;
    /**
     * 
     * @type {string}
     * @memberof BlogArticle
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogArticle
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof BlogArticle
     */
    'coverImage': string;
    /**
     * 
     * @type {string}
     * @memberof BlogArticle
     */
    'thumbnail': string;
    /**
     * 
     * @type {Array<BlogArticleElement>}
     * @memberof BlogArticle
     */
    'content': Array<BlogArticleElement>;
}
/**
 * 
 * @export
 * @interface BlogArticleElement
 */
export interface BlogArticleElement {
    /**
     * 
     * @type {ElementType}
     * @memberof BlogArticleElement
     */
    'type': ElementType;
    /**
     * 
     * @type {string}
     * @memberof BlogArticleElement
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BlogArticleElement
     */
    'caption'?: string | null;
    /**
     * 
     * @type {Array<BlogArticleElement>}
     * @memberof BlogArticleElement
     */
    'children'?: Array<BlogArticleElement> | null;
}


/**
 * 
 * @export
 * @interface BlogArticlePreview
 */
export interface BlogArticlePreview {
    /**
     * 
     * @type {number}
     * @memberof BlogArticlePreview
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof BlogArticlePreview
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof BlogArticlePreview
     */
    'hoverText': string;
    /**
     * 
     * @type {string}
     * @memberof BlogArticlePreview
     */
    'createdDate': string;
    /**
     * 
     * @type {string}
     * @memberof BlogArticlePreview
     */
    'thumbnail': string;
}
/**
 * 
 * @export
 * @interface CertArticle
 */
export interface CertArticle {
    /**
     * 
     * @type {number}
     * @memberof CertArticle
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CertArticle
     */
    'createdDate': string;
    /**
     * 
     * @type {string}
     * @memberof CertArticle
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CertArticle
     */
    'attachment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CertArticle
     */
    'url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CertArticle
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof CertArticle
     */
    'image'?: string | null;
}
/**
 * 
 * @export
 * @interface CertArticlePreview
 */
export interface CertArticlePreview {
    /**
     * 
     * @type {number}
     * @memberof CertArticlePreview
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CertArticlePreview
     */
    'createdDate': string;
    /**
     * 
     * @type {string}
     * @memberof CertArticlePreview
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CertArticlePreview
     */
    'attachment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CertArticlePreview
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface ContactRequest
 */
export interface ContactRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ContactRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ContactRequest
     */
    'message': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ElementType {
    Paragraph = 'paragraph',
    Image = 'image',
    Subtitle = 'subtitle',
    UList = 'uList',
    ListItem = 'listItem'
}


/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface JobApplication
 */
export interface JobApplication {
    /**
     * 
     * @type {string}
     * @memberof JobApplication
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof JobApplication
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof JobApplication
     */
    'cv': string;
    /**
     * 
     * @type {number}
     * @memberof JobApplication
     */
    'jobId': number;
}
/**
 * 
 * @export
 * @interface JobPosition
 */
export interface JobPosition {
    /**
     * 
     * @type {number}
     * @memberof JobPosition
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof JobPosition
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof JobPosition
     */
    'employment': string;
    /**
     * 
     * @type {string}
     * @memberof JobPosition
     */
    'location': string;
    /**
     * 
     * @type {string}
     * @memberof JobPosition
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface JobPositionPreview
 */
export interface JobPositionPreview {
    /**
     * 
     * @type {number}
     * @memberof JobPositionPreview
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof JobPositionPreview
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof JobPositionPreview
     */
    'employment': string;
    /**
     * 
     * @type {string}
     * @memberof JobPositionPreview
     */
    'location': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum Language {
    It = 'it',
    En = 'en'
}


/**
 * 
 * @export
 * @interface NestedFaqTreeItem
 */
export interface NestedFaqTreeItem {
    /**
     * 
     * @type {string}
     * @memberof NestedFaqTreeItem
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof NestedFaqTreeItem
     */
    'content'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof NestedFaqTreeItem
     */
    'images'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof NestedFaqTreeItem
     */
    'caption'?: string | null;
    /**
     * 
     * @type {Array<NestedFaqTreeItem>}
     * @memberof NestedFaqTreeItem
     */
    'children'?: Array<NestedFaqTreeItem> | null;
}
/**
 * 
 * @export
 * @interface StandardSearchResult
 */
export interface StandardSearchResult {
    /**
     * 
     * @type {string}
     * @memberof StandardSearchResult
     */
    'standard': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StandardSearchResult
     */
    'fields': Array<string>;
}
/**
 * 
 * @export
 * @interface StandardSearchResultList
 */
export interface StandardSearchResultList {
    /**
     * 
     * @type {Array<StandardSearchResult>}
     * @memberof StandardSearchResultList
     */
    'results': Array<StandardSearchResult>;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Riceve il form per candidarsi ad uan posizione lavorativa
         * @summary Applytoposition
         * @param {JobApplication} jobApplication 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyToPosition: async (jobApplication: JobApplication, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobApplication' is not null or undefined
            assertParamExists('applyToPosition', 'jobApplication', jobApplication)
            const localVarPath = `/backend/positions/apply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobApplication, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Riceve il form per i contatti
         * @summary Contact
         * @param {ContactRequest} contactRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contact: async (contactRequest: ContactRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactRequest' is not null or undefined
            assertParamExists('contact', 'contactRequest', contactRequest)
            const localVarPath = `/backend/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restituisce il contenuto completo di un articolo del blog
         * @summary Getblogarticle
         * @param {number} articleId 
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlogArticle: async (articleId: number, lang: Language, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('getBlogArticle', 'articleId', articleId)
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('getBlogArticle', 'lang', lang)
            const localVarPath = `/backend/blog/{articleId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restituisce le anteprime degli articoli del blog
         * @summary Getbloghome
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlogHome: async (lang: Language, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('getBlogHome', 'lang', lang)
            const localVarPath = `/backend/blog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restituisce i dettagli di un oggetto in qualsiasi sottocategoria della sezione Accreditation & Compliance
         * @summary Getcert
         * @param {number} certId 
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCert: async (certId: number, lang: Language, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certId' is not null or undefined
            assertParamExists('getCert', 'certId', certId)
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('getCert', 'lang', lang)
            const localVarPath = `/backend/certs/id/{certId}`
                .replace(`{${"certId"}}`, encodeURIComponent(String(certId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restituisce le anteprime degli oggetti nelle pagine Certifications, Compliance ecc.
         * @summary Getcertification
         * @param {string} type 
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCertification: async (type: string, lang: Language, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getCertification', 'type', type)
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('getCertification', 'lang', lang)
            const localVarPath = `/backend/certs/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restituisce i dettagli di una posizione lavorativa
         * @summary Getposition
         * @param {number} posId 
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosition: async (posId: number, lang: Language, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'posId' is not null or undefined
            assertParamExists('getPosition', 'posId', posId)
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('getPosition', 'lang', lang)
            const localVarPath = `/backend/positions/{posId}`
                .replace(`{${"posId"}}`, encodeURIComponent(String(posId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restituisce le anteprime delle posizioni lavorative
         * @summary Getpositions
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositions: async (lang: Language, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('getPositions', 'lang', lang)
            const localVarPath = `/backend/positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Restituisce i risultati della ricerca dello standard
         * @summary Getstandards
         * @param {string} standard 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStandards: async (standard: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'standard' is not null or undefined
            assertParamExists('getStandards', 'standard', standard)
            const localVarPath = `/backend/testing/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (standard !== undefined) {
                localVarQueryParameter['standard'] = standard;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gettechnology
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnology: async (lang: Language, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('getTechnology', 'lang', lang)
            const localVarPath = `/backend/technology`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gettesting
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTesting: async (lang: Language, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('getTesting', 'lang', lang)
            const localVarPath = `/backend/testing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Riceve il form per candidarsi ad uan posizione lavorativa
         * @summary Applytoposition
         * @param {JobApplication} jobApplication 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyToPosition(jobApplication: JobApplication, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyToPosition(jobApplication, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.applyToPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Riceve il form per i contatti
         * @summary Contact
         * @param {ContactRequest} contactRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contact(contactRequest: ContactRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contact(contactRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.contact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Restituisce il contenuto completo di un articolo del blog
         * @summary Getblogarticle
         * @param {number} articleId 
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBlogArticle(articleId: number, lang: Language, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlogArticle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBlogArticle(articleId, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBlogArticle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Restituisce le anteprime degli articoli del blog
         * @summary Getbloghome
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBlogHome(lang: Language, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BlogArticlePreview>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBlogHome(lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBlogHome']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Restituisce i dettagli di un oggetto in qualsiasi sottocategoria della sezione Accreditation & Compliance
         * @summary Getcert
         * @param {number} certId 
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCert(certId: number, lang: Language, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertArticle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCert(certId, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Restituisce le anteprime degli oggetti nelle pagine Certifications, Compliance ecc.
         * @summary Getcertification
         * @param {string} type 
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCertification(type: string, lang: Language, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CertArticlePreview>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCertification(type, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCertification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Restituisce i dettagli di una posizione lavorativa
         * @summary Getposition
         * @param {number} posId 
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPosition(posId: number, lang: Language, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobPosition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPosition(posId, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Restituisce le anteprime delle posizioni lavorative
         * @summary Getpositions
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositions(lang: Language, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobPositionPreview>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositions(lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPositions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Restituisce i risultati della ricerca dello standard
         * @summary Getstandards
         * @param {string} standard 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStandards(standard: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StandardSearchResultList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStandards(standard, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStandards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gettechnology
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTechnology(lang: Language, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NestedFaqTreeItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTechnology(lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTechnology']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gettesting
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTesting(lang: Language, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NestedFaqTreeItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTesting(lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTesting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Riceve il form per candidarsi ad uan posizione lavorativa
         * @summary Applytoposition
         * @param {JobApplication} jobApplication 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyToPosition(jobApplication: JobApplication, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.applyToPosition(jobApplication, options).then((request) => request(axios, basePath));
        },
        /**
         * Riceve il form per i contatti
         * @summary Contact
         * @param {ContactRequest} contactRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contact(contactRequest: ContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.contact(contactRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Restituisce il contenuto completo di un articolo del blog
         * @summary Getblogarticle
         * @param {number} articleId 
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlogArticle(articleId: number, lang: Language, options?: RawAxiosRequestConfig): AxiosPromise<BlogArticle> {
            return localVarFp.getBlogArticle(articleId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Restituisce le anteprime degli articoli del blog
         * @summary Getbloghome
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlogHome(lang: Language, options?: RawAxiosRequestConfig): AxiosPromise<Array<BlogArticlePreview>> {
            return localVarFp.getBlogHome(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Restituisce i dettagli di un oggetto in qualsiasi sottocategoria della sezione Accreditation & Compliance
         * @summary Getcert
         * @param {number} certId 
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCert(certId: number, lang: Language, options?: RawAxiosRequestConfig): AxiosPromise<CertArticle> {
            return localVarFp.getCert(certId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Restituisce le anteprime degli oggetti nelle pagine Certifications, Compliance ecc.
         * @summary Getcertification
         * @param {string} type 
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCertification(type: string, lang: Language, options?: RawAxiosRequestConfig): AxiosPromise<Array<CertArticlePreview>> {
            return localVarFp.getCertification(type, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Restituisce i dettagli di una posizione lavorativa
         * @summary Getposition
         * @param {number} posId 
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosition(posId: number, lang: Language, options?: RawAxiosRequestConfig): AxiosPromise<JobPosition> {
            return localVarFp.getPosition(posId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Restituisce le anteprime delle posizioni lavorative
         * @summary Getpositions
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositions(lang: Language, options?: RawAxiosRequestConfig): AxiosPromise<Array<JobPositionPreview>> {
            return localVarFp.getPositions(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Restituisce i risultati della ricerca dello standard
         * @summary Getstandards
         * @param {string} standard 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStandards(standard: string, options?: RawAxiosRequestConfig): AxiosPromise<StandardSearchResultList> {
            return localVarFp.getStandards(standard, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gettechnology
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnology(lang: Language, options?: RawAxiosRequestConfig): AxiosPromise<Array<NestedFaqTreeItem>> {
            return localVarFp.getTechnology(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gettesting
         * @param {Language} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTesting(lang: Language, options?: RawAxiosRequestConfig): AxiosPromise<Array<NestedFaqTreeItem>> {
            return localVarFp.getTesting(lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Riceve il form per candidarsi ad uan posizione lavorativa
     * @summary Applytoposition
     * @param {JobApplication} jobApplication 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public applyToPosition(jobApplication: JobApplication, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).applyToPosition(jobApplication, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Riceve il form per i contatti
     * @summary Contact
     * @param {ContactRequest} contactRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public contact(contactRequest: ContactRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).contact(contactRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restituisce il contenuto completo di un articolo del blog
     * @summary Getblogarticle
     * @param {number} articleId 
     * @param {Language} lang 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBlogArticle(articleId: number, lang: Language, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBlogArticle(articleId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restituisce le anteprime degli articoli del blog
     * @summary Getbloghome
     * @param {Language} lang 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBlogHome(lang: Language, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBlogHome(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restituisce i dettagli di un oggetto in qualsiasi sottocategoria della sezione Accreditation & Compliance
     * @summary Getcert
     * @param {number} certId 
     * @param {Language} lang 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCert(certId: number, lang: Language, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCert(certId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restituisce le anteprime degli oggetti nelle pagine Certifications, Compliance ecc.
     * @summary Getcertification
     * @param {string} type 
     * @param {Language} lang 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCertification(type: string, lang: Language, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCertification(type, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restituisce i dettagli di una posizione lavorativa
     * @summary Getposition
     * @param {number} posId 
     * @param {Language} lang 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPosition(posId: number, lang: Language, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPosition(posId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restituisce le anteprime delle posizioni lavorative
     * @summary Getpositions
     * @param {Language} lang 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPositions(lang: Language, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPositions(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Restituisce i risultati della ricerca dello standard
     * @summary Getstandards
     * @param {string} standard 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStandards(standard: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStandards(standard, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gettechnology
     * @param {Language} lang 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTechnology(lang: Language, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTechnology(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gettesting
     * @param {Language} lang 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTesting(lang: Language, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTesting(lang, options).then((request) => request(this.axios, this.basePath));
    }
}



